import { Helmet } from "react-helmet-async";

interface SEOHeadProps {
  title: string;
  description: string;
  canonical?: string;
  type?: string;
  image?: string;
  noindex?: boolean;
  publishedTime?: string;
  modifiedTime?: string;
  author?: string;
  section?: string;
}

const cleanCanonical = (url: string) => {
  try {
    const u = new URL(url);
    return `${u.origin}${u.pathname.replace(/\/+$/, "") || "/"}`;
  } catch {
    return url;
  }
};

const SEOHead = ({
  title,
  description,
  canonical,
  type = "website",
  image = "https://momandpopinsurance.com/og-image.png",
  noindex = false,
  publishedTime,
  modifiedTime,
  author,
  section,
}: SEOHeadProps) => {
  const SUFFIX_FULL = " | Mom & Pop Insurance Shop";
  const SUFFIX_SHORT = " | Mom & Pop";
  let fullTitle = title.includes("Mom & Pop") ? title : `${title}${SUFFIX_FULL}`;
  if (fullTitle.length > 60 && !title.includes("Mom & Pop")) {
    fullTitle = `${title}${SUFFIX_SHORT}`;
  }
  if (fullTitle.length > 60) fullTitle = fullTitle.slice(0, 60).trimEnd();
  const cleanUrl = canonical ? cleanCanonical(canonical) : undefined;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {cleanUrl && <link rel="canonical" href={cleanUrl} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Mom & Pop Insurance Shop" />
      <meta property="og:locale" content="en_US" />
      {cleanUrl && <meta property="og:url" content={cleanUrl} />}
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      {author && <meta property="article:author" content={author} />}
      {section && <meta property="article:section" content={section} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* RSS auto-discovery */}
      <link rel="alternate" type="application/rss+xml" title="Mom & Pop Insurance Shop Blog" href="https://momandpopinsurance.com/rss.xml" />
    </Helmet>
  );
};

export default SEOHead;
